import styled from "styled-components";
import { BG_GAMES, BOX_SHADOW, DARKER, PRIMARY, SECONDARY } from "../../const/colors";

export const Container = styled.div.attrs((props) => ({
	className: props.className,
}))`
  position: relative;
  background-color: ${DARKER};
  @media screen and (max-width: 1080px) {
    &.loged {
      margin-top: 70px;
    }
    &:not(.loged) {
      margin-top: 5rem;
    }
  }

  @media screen and (max-width: 480px) {
    &:not(.loged) {
      margin-top: 4rem;
    }
  }
`;
export const Movildiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
export const MenuContainer = styled.div`

position: relative;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  margin: auto;
  width:100%;
  padding:0rem 1%;
  @media screen and (max-width: 1300px) {
    max-width: calc(90%);
  }
  @media screen and (max-width: 768px) {
    flex-direction: column;
    margin-top: 0;
    border: none;
    max-width: calc(100%);
    padding:15px;
    padding-bottom:0px;
  }

  /*display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  margin: auto;
  max-width: 1222px;

  @media screen and (max-width: 1300px) {
    max-width: calc(90%);
  }
  @media screen and (max-width: 768px) {
    //flex-direction: column;
    //justify-content: flex-start;
    margin-top: 0;
    border: none;
    max-width: calc(100%);
    min-width: calc(100%);
  }*/
`;

export const AllCategories = styled.div`
  background-color: ${DARKER};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;

  @media screen and (max-width: 1300px) {
    max-width: 100vw;
    align-items: flex-start;
  }
  @media screen and (max-width: 768px) {
    padding-top: 0;
    //margin-top: 1rem;
  }
`;

export const BannerDesktop = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 1910px;
  position:relative;
  .slick-initialized .slick-slide{
    filter: blur(2px);
    transition:1s all;
  }
  .slick-initialized .slick-slide.slick-active{
    filter: blur(0px);
    transition:1s all;
  }
  ::before{
    content: "";
    position: absolute;
    left: 0px;
    right: 100%;
    background: linear-gradient(to right, #000000cc, transparent);
    z-index: 99;
    height: 100%;
    width: calc(6rem);
    pointer-events: none;
  }
  ::after{
    content: "";
    position: absolute;
    top:0px;
    right: 0px;
    background: linear-gradient(to left, #000000cc, transparent);
    z-index: 99;
    height: 100%;
    width: calc(6rem);
    pointer-events: none;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const BannerMobile = styled.div`
  width: 100%;
  margin: 0 auto;
  display: none;
  @media screen and (max-width: 768px) {
    display: block;
  }
`;

export const Content = styled.div`
  position: relative;
  border-top: 1px solid ${PRIMARY};
  text-align: center;
  padding-bottom: 4rem;
  
  @media screen and (max-width: 768px) {
    //padding: 3rem 0;
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 120px + 4vw), 1fr));
  grid-auto-flow: dense;
  grid-auto-rows: 200px;
  justify-content: center;
  grid-row-gap: 10px;
  grid-column-gap: 10px;
  @media screen and (max-width: 1480px) {
    grid-template-columns: repeat(auto-fit, 19%);
  }
  @media screen and (max-width: 1170px) {
    grid-template-columns: repeat(auto-fit, 22%);
  }
  @media screen and (max-width: 1024px) {
    grid-gap: 0.5rem;
    grid-template-columns: repeat(auto-fit, 24%);
    grid-auto-rows: 200px;
  }
  @media screen and (max-width: 768px) {
    grid-gap: 0.5rem;
    grid-template-columns: repeat(auto-fit, 32%);
    grid-auto-rows: 235px;
  }
  @media screen and (max-width: 580px) {
    grid-gap: 0.5rem;
    grid-template-columns: repeat(auto-fit, 48%);
    grid-auto-rows: 180px;
  }
`;

export const Button = styled.button`
  font-size: 1.1rem;
  font-weight: 600;
  margin: 4rem auto;
	border: none;
  background-color: ${PRIMARY};
  color: ${SECONDARY};
  box-shadow: ${BOX_SHADOW};
  padding: 0.6rem 0.7rem;
  cursor: pointer;
  transition: all .3s ease-in-out;
  
  &:hover{
    background-color: #fff;
    transform: scale(1.05);
  }
  @media screen and (max-width: 750px) {

    width: 100%!important;
    min-width: 0!important;
    margin: 0!important;
  }
  @media screen and (max-width: 2000px) {
    font-size: 0.9rem;
  }
`;

export const ContainerModal = styled.div`
  background-color: ${DARKER};
  text-align: right;
  height: 100%;
  overflow: hidden;
  padding-top: 1rem;
  > div button {
    margin: 1rem;
  }
  .closebtn{
    position:absolute;
    top:0;
    right:0;
  }
  iframe{
    width: 100%;
    height: 98%;
    border: none;
    margin: 0px;
    padding: 0px;
  }
  @media screen and (max-width: 1080px) {
    padding-top: 4rem;
    .closebtn{
      position: relative;
      bottom: 0;
      right: 0;
      top: 0;
      text-align: center;
    }
    > div button {
      padding: 0.7rem;
    }
    iframe{
      width: 100%; 
      height: 93%; 
      border:none;
      margin: 0px; 
      padding: 0px;
    }
  }
`;
export const EmptyResult = styled.div`
  color: #fff;
  font-weight: bold;
  text-align: center;
  padding: 1rem;
`;
export const ContentWrapper = styled.div`
  padding: 0 10%;
  margin-top: 1rem;
  padding-bottom: 4rem;
  text-align: center;
  @media screen and (max-width: 2000px) {
    padding: 0 1%;
  }
  @media screen and (max-width: 768px) {
    padding: 15px;
  }
  @media screen and (max-width: 480px) {
    margin-top: 0;
  }
`;
export const Title = styled.span`
  position:relative;
  display: inline-flex;
  font-size: 2.2rem;
  color: white;
  margin-bottom:2rem;
  font-weight: 800;
  &::after {
		content: "";
		height: 2px;
		background: ${PRIMARY};
		position: absolute;
		left: 0;
		right: 0;
		bottom: -6px;
		transform: scaleX(1);
    opacity: 1;
		transform-origin: left center;
		transition: all 0.25s cubic-bezier(0.25, 0.43, 0.45, 0.94) 0s;
	  }
  & > svg{
    width: 32px;
    height: 32px;
    transition: transform 0.3s ease-in-out 0s;
    fill: ${PRIMARY};
    margin-right:10px;
  }
  @media screen and (max-width: 480px) {
    font-size: 1.5rem;
  }
`;